<script>
  import { fade } from 'svelte/transition';

  import { saveClient, logout, userStore, changeClient, clientStore } from '../services/session'
  import { _ } from '../services/i18n'
  import Icon from '../ui/Icon.svelte'

  import svgCheck from "../../public/icons/check2.svg"
  import svgCross from "../../public/icons/x-lg.svg"

  export let isOpen = false
  
  let textFilter = ''
  let selected = $clientStore ? Number($clientStore) : false
    
  const accept = () => {
    if($changeClient) {
      changeClient.changed()
    }
    saveClient(selected)
    textFilter = ''
    isOpen = false
  }

  let allClients = []
  userStore.subscribe(user => {
    allClients = user.clients;

    if (allClients.length === 1 && !selected) {
      selected = allClients[0].id;
      accept();
    }
  })

  $: isOpen = ($userStore.login && !$clientStore) || $changeClient
  $: clientesFiltrados = textFilter ?
      allClients.filter(c => {
        const re = new RegExp(textFilter, 'i');
        return c.name?.match(re) || String(c.id).match(re) || c.fiscalName?.match(re)
      }) : 
      allClients
</script>

{#if isOpen}
<div class="overlay"></div>
<div class="modal-fade-show">
  <div transition:fade class="modal-dialog">
    <div class="modal-content">
      <header>
        <h1> {$_('clientSelector_title')}</h1>
        <div class="circle"><img id="user" src="/icons/user-white.svg" alt="close"/></div>
      </header>   
        <div class="header">
          <img src="/icons/search-sim3d.svg" alt="close" style="position: absolute; left: 0"/> 
          <input type="text" class="input-client-find" placeholder={$_("clientSelector_filter")} bind:value={textFilter}/>
        </div>
      
      <body>
        <h2> {$_('clientSelector_id')} | {$_('clientSelector_name')} | {$_('clientSelector_fiscalName')}</h2>
        <ul class="list-inline s3d-search-bar-options">
        {#each (clientesFiltrados ?? []) as client (client.id)}
          <li class:active={selected===client.id} on:keypress={() => selected = client.id } on:click={() => selected = client.id}>
            <span style="margin-right:10px">{client.id}</span> ·
            <span style="margin-right:10px">{client.name}</span> ·
            <span>{client.fiscalName}</span>
          </li>
        {/each}
        </ul>
      </body>
      <footer class='justify-center'>
        {#if !$changeClient}
        <button on:click={logout} class="btn-3d second icon-svg">
          <Icon svg={svgCross} class="icon-svg" style="width: 15px; stroke-width: 1px; margin-right: 10px;"/>
          {$_('clientSelector_close')}
        </button>
        {:else}
        <button on:click={changeClient.changed} class="btn-3d second icon-svg">
          <Icon svg={svgCross} class="icon-svg" style="width: 15px; stroke-width: 1px; margin-right: 10px;"/>
          {$_('clientSelector_cancel')}
        </button>
        {/if}
        <button on:click={accept} disabled={!selected} class="btn-3d third icon-svg">
          <Icon svg={svgCheck} class="icon-svg" style="width: 15px; stroke-width: 0.8px; margin-right: 10px;"/>
          {$_('clientSelector_ok')}
        </button>
      </footer>
    </div>
  </div>
</div>
{/if}

<style>
  .overlay {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: #0008;
    z-index: 1000;
  }
  .modal-fade-show {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1060;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0;
  }

  .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: .3rem;
    outline: 0;
  }
  .modal-dialog {
    max-width: 800px;
    margin: 1.75rem auto;
    position: relative;
    width: auto;
    pointer-events: none;
  }

  header {
    background-color: var(--theme-color-4);
    height: 120px;
  }

  header h1 {
    color: white;
    letter-spacing: 1.7px;
    padding: 0px 15px;
    text-align: center;
    font-size: 22px;
    font-weight: 300;
    margin-top: 30px;
    text-transform: uppercase;
  }

  h2 {
    color: var(--theme-color-3);
    width: 100%;
    padding: 0 30px;
    font-size: 20px;
    font-weight: 300;
    letter-spacing: 1.7px;
    margin-bottom: 0;
    text-transform: uppercase;
  }
  .header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    border-bottom: 1px solid var(--theme-color-4) !important;
    width: 90%;
    left: 5%;
    position: relative;
    margin: 60px 0 50px;
  }

  .header img {
    height: 20px;

  }

  input {
    margin: 10px;
  }

  input {
    border: 1px solid #ddd;
    border-radius: 5px;
  }

  ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    max-height: 45vh;
    overflow-y: auto;
    scrollbar-width: thin;
    padding: 5px 0;
    width: 90%;
    position: relative;
    left: 5%;
    margin: 10px 30px 30px 0px;
  }

  li {
    margin-bottom: -1px;
    border: #ddd 1px solid;
    border-collapse: collapse;
    padding: 10px 15px;
    text-align: start;
    cursor: pointer;
    color: var(--theme-color-4);
    letter-spacing: 1.5px;
    font-size: 14px;
    text-transform: uppercase;
  }

  li:first-child {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  li:last-child {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

::-webkit-scrollbar {
  width: 4px;
  height: 20%;
}

::-webkit-scrollbar-track {
  background-color: #1b32588f;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb {
  background-color: var(--theme-color-4);
  border-radius: 5px;
  height: 20%;
}
  .active {
    color: var(--theme-color-1);
  }

  .input-client-find {
    border: 1px solid transparent;
    border-radius: 0px;
    width: 100%;
    margin: 0px;
    padding: 0px;
    color: var(--theme-color-4);
    text-align: center;
    letter-spacing: 1.5px;
  }

  .input-client-find:hover, .input-client-find:focus, .input-client-find:active, .input-client-find:focus-visible {
    border: 1px solid transparent;
    outline: none;
  }

  .input-client-find::placeholder {
    text-align: center;
    color: var(--theme-color-4);
    letter-spacing: 1.5px;
  }


  li {
    margin-bottom: -1px;
    border-bottom: #ddd 1px solid !important;
    border: 1px solid transparent;
    border-collapse: collapse;
    padding: 10px;
    text-align: start;
    cursor: pointer;
  }

  #user {
    height: 45px;
    width: 50px;
    margin: 25px;

  }

  .circle {
    height: 100px;
    width: 100px;
    border-radius: 50%;
    background-color: var(--theme-color-4);
    margin: 0 auto;
    position: relative;
  
  }

  footer {
    display: inline-flex;
    justify-content: center;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    align-items: flex-start;
    margin: 15px;
    margin-bottom: 40px;
    gap: 15px;
  }



  @media (max-width: 768px) {
    
  .modal-dialog  {
    margin: 0.5rem; 
  }

  ul {
    overflow-y: none;
    max-height: 230px;
  }
  
  .header {
    margin: 50px 0 20px;
  }

  header {
    height: 90px;
  }
  .circle {
    height: 80px;
    width: 80px;
    margin: -12px auto;
   
}

#user {
    height: 35px;
    width: 30px;
}

header h1 {
    color: white;
    letter-spacing: 1.7px;
    padding: 0px 15px;
    text-align: center;
    font-size: 20px;
    font-weight: 300;
    margin-top: 30px;
    text-transform: uppercase;
}

}

@media (min-width: 0px) and (max-width: 455px) {
  .icon-svg {
      width: 45% !important;
      font-size: 14px !important;
      min-height: 62px;
  }
}
</style>